import { FC } from 'react'

import { Card } from '@joor/design-system'

import { Flex } from 'styles/components'

import { Order } from '../../types'
import { CardItemHeader, CardItemInfo } from './styles'

const BillingInfo: FC<{ order: Order }> = ({ order }) => (
  <Card title="Billing Info">
    <Flex flexDirection="column" rowGap="20px">
      <div>
        <CardItemHeader>Billing Address</CardItemHeader>
        {order.billingAddress.map((data: string) => (
          <CardItemInfo key={data}>{data}</CardItemInfo>
        ))}
      </div>
      <div>
        <CardItemHeader> Phone Number</CardItemHeader>
        <CardItemInfo>{order.billingPhone}</CardItemInfo>
      </div>
    </Flex>
  </Card>
)
export default BillingInfo
